import styled, { css } from 'styled-components'

const StyledReadMoreContainer = styled.div`
  overflow: hidden;
  ${props =>
    props.isVisible
      ? css`
          max-height: 100%;
        `
      : css`
          max-height: ${props.height}px;
        `};
`

export default StyledReadMoreContainer
